// @ts-nocheck

/**
 * * `performer` - performer
 * `describer` - describer
 * `comprehender` - comprehender
 */
export type ReaderProfileDataParentReadingStyleEnum =
  typeof ReaderProfileDataParentReadingStyleEnum[keyof typeof ReaderProfileDataParentReadingStyleEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReaderProfileDataParentReadingStyleEnum = {
  performer: "performer",
  describer: "describer",
  comprehender: "comprehender",
} as const;
